const articles = [
  {
    title: "The principal product designer's journey: 4 OKRs to track success, 6 learnings for growth",
    desc: "Reflections on a 4-year journey as Principal Product Designer at Grab, covering OKRs and key learnings for IC leadership.",
    publication: "Medium",
    date: "Oct 2024",
    url: "https://medium.com/@ricetseng_0820/the-principal-product-designers-journey-4-okrs-to-track-success-6-learnings-for-growth-e06ad3d227a4",
  },
  {
    title: "Grab 東南亞交通運輸的產品設計挑戰與實踐 — 以重新設計 Grab app 為例",
    desc: "Case study on redesigning the Grab app for Southeast Asia — design challenges and implementation across multiple countries and languages.",
    publication: "AAPD",
    date: "Nov 2018",
    url: "https://medium.com/as-a-product-designer/grab-%E6%9D%B1%E5%8D%97%E4%BA%9E%E4%BA%A4%E9%80%9A%E9%81%8B%E8%BC%B8%E7%9A%84%E7%94%A2%E5%93%81%E8%A8%AD%E8%A8%88%E6%8C%91%E6%88%B0%E8%88%87%E5%AF%A6%E8%B8%90-%E4%BB%A5%E9%87%8D%E6%96%B0%E8%A8%AD%E8%A8%88-grab-app-%E7%82%BA%E4%BE%8B-38cb03d7ab06",
  },
  {
    title: "Redesigning the transport booking experience for Grab app",
    desc: "How the team at Grab redesigned the transport booking experience for millions of users across Southeast Asia.",
    publication: "UX Collective",
    date: "Nov 2018",
    url: "https://uxdesign.cc/redesigning-the-transport-booking-experience-for-grab-app-52fbe796c36c",
  },
  {
    title: "Some tips on how to make your interviewer impressed",
    desc: "Guidance for emerging product designers on portfolio development, resume writing, and interview presentation — from an interviewer's perspective.",
    publication: "AAPD",
    date: "Apr 2017",
    url: "https://medium.com/as-a-product-designer/some-tips-on-how-to-make-your-interviewer-impressed-ea671c62dfb3",
  },
  {
    title: "The Thinking Behind Micro-interaction",
    desc: "Exploration of meaningful interaction design — the planning and thinking process before prototyping, beyond just complex animations.",
    publication: "Design Nation",
    date: "Dec 2016",
    url: "https://design-nation.icons8.com/the-thinking-behind-micro-interaction-b6e9f7010491",
  },
]

export default function Writing() {
  return (
    <div className="page-panel">
      <div className="panel-inner">

        <div className="panel-header">
          <div className="panel-tag">Writing &amp; Book</div>
          <h2 className="panel-title">Essays,<br />Ideas &amp;<br />Book</h2>
          <p className="panel-subtitle">
            Writing on design leadership, product craft, and building
            teams that do meaningful work.
          </p>
        </div>

        {/* ── Book ─────────────────────────────── */}
        <div className="section-heading">Book</div>

        <div className="book-feature">
          <div className="book-cover">
            <img src="/image-8-book.jpg" alt="Rice Tseng — Biography Book" />
          </div>
          <div className="book-info">
            <div className="book-year">2025</div>
            <h3 className="book-title">My biography book</h3>
            <p className="book-desc">
              After years of mentoring and having countless 1-on-1 conversations with
              designers navigating career transitions, I put those stories and
              reflections into a book.
            </p>
            <p className="book-desc">
              A very personal story — about taking risks, finding direction, and
              growing through uncertainty. For anyone at a crossroads in their career
              or life.
            </p>
            <div className="book-stores">
              <div className="book-stores-label">實體書 Print</div>
              <div className="book-store-links">
                <a href="https://reurl.cc/lN8oGq" target="_blank" rel="noopener noreferrer" className="book-store-link">博客來 ↗</a>
                <a href="https://reurl.cc/aZQGql" target="_blank" rel="noopener noreferrer" className="book-store-link">城邦讀書花園 ↗</a>
                <a href="https://reurl.cc/zp0NqQ" target="_blank" rel="noopener noreferrer" className="book-store-link">金石堂網路書店 ↗</a>
                <a href="https://reurl.cc/kMmEMr" target="_blank" rel="noopener noreferrer" className="book-store-link">誠品網路書店 ↗</a>
                <a href="https://reurl.cc/EgkRY0" target="_blank" rel="noopener noreferrer" className="book-store-link">momo ↗</a>
              </div>
              <div className="book-stores-physical">實體書店 In stores：誠品・金石堂・各連鎖書店</div>

              <div className="book-stores-label" style={{ marginTop: 20 }}>電子書 Ebook</div>
              <div className="book-store-links">
                <a href="https://dub.sh/RTLnzz5" target="_blank" rel="noopener noreferrer" className="book-store-link">Readmoo 讀墨 ↗</a>
                <a href="https://dub.sh/xZPKVmI" target="_blank" rel="noopener noreferrer" className="book-store-link">樂天 Kobo ↗</a>
                <a href="https://dub.sh/dqXU7ec" target="_blank" rel="noopener noreferrer" className="book-store-link">博客來 ↗</a>
                <a href="https://dub.sh/5tc4n1M" target="_blank" rel="noopener noreferrer" className="book-store-link">Google 圖書 ↗</a>
                <a href="https://dub.sh/D5zV9Y0" target="_blank" rel="noopener noreferrer" className="book-store-link">Amazon ↗</a>
              </div>
            </div>
          </div>
        </div>

        {/* ── Articles ─────────────────────────── */}
        <div className="section-heading" style={{ marginTop: 80 }}>Articles</div>

        <ul className="writing-list">
          {articles.map((article, i) => (
            <li key={i}>
              <a
                href={article.url}
                className="writing-item"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div>
                  <div className="writing-item-title">{article.title}</div>
                  <p className="writing-item-desc">{article.desc}</p>
                </div>
                <div className="writing-item-meta">
                  <span className="writing-item-pub">{article.publication}</span>
                  <span className="writing-item-date">{article.date}</span>
                </div>
              </a>
            </li>
          ))}
        </ul>

        <div style={{ marginTop: 48, paddingTop: 32, borderTop: "1px solid var(--border)" }}>
          <a
            href="https://medium.com/@ricetseng_0820"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: 12,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "var(--fg-dim)",
              textDecoration: "none",
            }}
          >
            All articles on Medium ↗
          </a>
        </div>

      </div>
    </div>
  )
}
